import '../sass/service-header.scss';

import consultAnimationData from '../../../../assets/lottie/service-consult-white.json';
import designAnimationData from '../../../../assets/lottie/service-design-white.json';
import integrateAnimationData from '../../../../assets/lottie/service-integrate-white.json';
import supportAnimationData from '../../../../assets/lottie/service-support-white.json';

const serviceAnimations = {
    'consult': consultAnimationData,
    'design': designAnimationData,
    'integrate': integrateAnimationData,
    'support': supportAnimationData,
};

(() => {
    const lottieScript = document.querySelector('#boomspace-theme-lottie-js');
    const $blocks = document.querySelectorAll('.service-header');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $container = $block.querySelector('.service-header__container');
        const $serviceIcon = $block.querySelector('.service-header__icon-inner');

        const initIconAnimation = () => {
            if (!$serviceIcon) return;

            const { serviceIcon } = $serviceIcon.dataset;

            if (!serviceIcon || !serviceAnimations[serviceIcon]) return;

            const iconAnimation = lottie.loadAnimation({
                container: $serviceIcon,
                renderer: 'canvas',
                animationData: serviceAnimations[serviceIcon],
                initialSegment: [0, 80],
                loop: false,
                autoplay: false,
            });

            const playAnimation = () => {
                iconAnimation.goToAndStop(0);

                setTimeout(() => {
                    iconAnimation.goToAndPlay(0);
                }, 600);
            };

            if ($container.classList.contains('is-on-screen')) {
                playAnimation();
            }

            $container.addEventListener('onScreen', () => {
                playAnimation();
            });
        };

        if (lottie) {
            initIconAnimation();
        } else {
            lottieScript.addEventListener('load', () => {
                initIconAnimation();
            });
        }
    });
})();
